/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RunBatchRequest
 */
export interface RunBatchRequest {
    /**
     * 対象サービス（service_category）
     * @type {number}
     * @memberof RunBatchRequest
     */
    serviceCategory: RunBatchRequestServiceCategoryEnum | null;
    /**
     * 実施日
     * @type {Date}
     * @memberof RunBatchRequest
     */
    issueDate: Date;
    /**
     * 集計対象期間（開始日）
     * @type {Date}
     * @memberof RunBatchRequest
     */
    startDate: Date;
    /**
     * 集計対象期間（終了日）
     * @type {Date}
     * @memberof RunBatchRequest
     */
    endDate: Date;
    /**
     * 冪等実行キー（同一 operation の再試行で同一値を使用）
     * @type {string}
     * @memberof RunBatchRequest
     */
    transactionToken: string;
}


/**
 * @export
 */
export const RunBatchRequestServiceCategoryEnum = {
    OVERSEAS_ROAMING: 0
} as const;
export type RunBatchRequestServiceCategoryEnum = typeof RunBatchRequestServiceCategoryEnum[keyof typeof RunBatchRequestServiceCategoryEnum];


/**
 * Check if a given object implements the RunBatchRequest interface.
 */
export function instanceOfRunBatchRequest(value: object): value is RunBatchRequest {
    if (!('serviceCategory' in value) || value['serviceCategory'] === undefined) return false;
    if (!('issueDate' in value) || value['issueDate'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('transactionToken' in value) || value['transactionToken'] === undefined) return false;
    return true;
}

export function RunBatchRequestFromJSON(json: any): RunBatchRequest {
    return RunBatchRequestFromJSONTyped(json, false);
}

export function RunBatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunBatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceCategory': json['service_category'],
        'issueDate': (new Date(json['issue_date'])),
        'startDate': (new Date(json['start_date'])),
        'endDate': (new Date(json['end_date'])),
        'transactionToken': json['transaction_token'],
    };
}

export function RunBatchRequestToJSON(json: any): RunBatchRequest {
    return RunBatchRequestToJSONTyped(json, false);
}

export function RunBatchRequestToJSONTyped(value?: RunBatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'service_category': value['serviceCategory'],
        'issue_date': ((value['issueDate']).toISOString().substring(0,10)),
        'start_date': ((value['startDate']).toISOString().substring(0,10)),
        'end_date': ((value['endDate']).toISOString().substring(0,10)),
        'transaction_token': value['transactionToken'],
    };
}

